import React from 'react';
import TransactionLine from "./components/TransactionLine";
import { ClockIcon } from "@heroicons/react/24/outline";

function TransactionList({transactions}) {
    if (!transactions?.length) return (
        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-8 py-6 border-b border-gray-50 flex items-center gap-3">
                <div className="p-2.5 rounded-2xl bg-[#0b6a8c]/10">
                    <ClockIcon className="h-6 w-6 text-[#0b6a8c]" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">Transaction History</h3>
            </div>
            <div className="p-10 text-center">
                <p className="text-gray-400 font-medium">No transactions found</p>
            </div>
        </div>
    );

    const transactionLines = transactions?.map((transaction) => (
        <TransactionLine key={transaction?.id} transaction={transaction} />
    ));

    return (
        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-8 py-6 border-b border-gray-50 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="p-2.5 rounded-2xl bg-[#0b6a8c]/10">
                        <ClockIcon className="h-6 w-6 text-[#0b6a8c]" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900">Transaction History</h3>
                </div>
                <span className="bg-cyan-50 text-[#0b5f82] text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full">
                    {transactions?.length}
                </span>
            </div>

            <div className="overflow-x-auto">
                <div className="inline-block min-w-full align-middle p-4 sm:p-6">
                    <div className="min-w-[800px]">
                        <table className="min-w-full divide-y divide-gray-100">
                            <thead className="bg-gray-50/50">
                            <tr>
                                <th className="px-4 py-3.5 first:pl-8 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Invoice Ref</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Transaction Id</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Auth Code</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Card Number</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Status</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Description</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Created At</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-50">
                            {transactionLines}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TransactionList;
